/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserGroupUpdate
 */
export interface UserGroupUpdate {
    /**
     * 
     * @type {string}
     * @memberof UserGroupUpdate
     */
    label?: string | null;
    /**
     * `VehicleGroup`s for which new assignments should be created.
     * @type {Array<string>}
     * @memberof UserGroupUpdate
     */
    addVehicleGroupIds?: Array<string> | null;
    /**
     * `VehicleGroup`s for which existing assignments should be removed.
     * @type {Array<string>}
     * @memberof UserGroupUpdate
     */
    removeVehicleGroupIds?: Array<string> | null;
    /**
     * `User`s for which new assignments should be created.
     * @type {Array<string>}
     * @memberof UserGroupUpdate
     */
    addUserIds?: Array<string> | null;
    /**
     * `User`s for which existing assignments should be removed.
     * @type {Array<string>}
     * @memberof UserGroupUpdate
     */
    removeUserIds?: Array<string> | null;
}

/**
 * Check if a given object implements the UserGroupUpdate interface.
 */
export function instanceOfUserGroupUpdate(value: object): value is UserGroupUpdate {
    return true;
}

export function UserGroupUpdateFromJSON(json: any): UserGroupUpdate {
    return UserGroupUpdateFromJSONTyped(json, false);
}

export function UserGroupUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'addVehicleGroupIds': json['addVehicleGroupIds'] == null ? undefined : json['addVehicleGroupIds'],
        'removeVehicleGroupIds': json['removeVehicleGroupIds'] == null ? undefined : json['removeVehicleGroupIds'],
        'addUserIds': json['addUserIds'] == null ? undefined : json['addUserIds'],
        'removeUserIds': json['removeUserIds'] == null ? undefined : json['removeUserIds'],
    };
}

export function UserGroupUpdateToJSON(json: any): UserGroupUpdate {
    return UserGroupUpdateToJSONTyped(json, false);
}

export function UserGroupUpdateToJSONTyped(value?: UserGroupUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'addVehicleGroupIds': value['addVehicleGroupIds'],
        'removeVehicleGroupIds': value['removeVehicleGroupIds'],
        'addUserIds': value['addUserIds'],
        'removeUserIds': value['removeUserIds'],
    };
}

